module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/milk-shake@2x_374209.jpg";